"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var model_1 = require("../diagram/model");
var events_1 = require("../viewUtils/events");
var async_1 = require("../viewUtils/async");
var SelectLinkType = /** @class */ (function (_super) {
    tslib_1.__extends(SelectLinkType, _super);
    function SelectLinkType(props) {
        var _this = _super.call(this, props) || this;
        _this.listener = new events_1.EventObserver();
        _this.cancellation = new async_1.Cancellation();
        _this.updateAll = function () { return _this.forceUpdate(); };
        _this.onChangeType = function (e) {
            var linkTypeId = e.currentTarget.value;
            _this.props.onChange(tslib_1.__assign({}, _this.props.link, { linkTypeId: linkTypeId }));
        };
        _this.state = { fatLinkTypes: {} };
        return _this;
    }
    SelectLinkType.prototype.componentDidMount = function () {
        var _a = this.props, source = _a.source, target = _a.target;
        this.fetchPossibleLinkTypes(source, target);
    };
    SelectLinkType.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.source !== this.props.source || nextProps.target !== this.props.target) {
            this.fetchPossibleLinkTypes(nextProps.source, nextProps.target);
        }
    };
    SelectLinkType.prototype.componentWillUnmount = function () {
        this.listener.stopListening();
        this.cancellation.abort();
    };
    SelectLinkType.prototype.fetchPossibleLinkTypes = function (source, target) {
        var _this = this;
        var _a = this.props, view = _a.view, metadataApi = _a.metadataApi;
        if (!metadataApi) {
            return;
        }
        metadataApi.possibleLinkTypes(source, target, this.cancellation.signal).then(function (linkTypes) {
            var fatLinkTypes = {};
            linkTypes.forEach(function (linkTypeIri) { return fatLinkTypes[linkTypeIri] = view.model.createLinkType(linkTypeIri); });
            _this.setState({ fatLinkTypes: fatLinkTypes });
            _this.listenToLinkLabels(fatLinkTypes);
        });
    };
    SelectLinkType.prototype.listenToLinkLabels = function (fatLinkTypes) {
        var _this = this;
        Object.keys(fatLinkTypes).forEach(function (linkType) {
            return _this.listener.listen(fatLinkTypes[linkType].events, 'changeLabel', _this.updateAll);
        });
    };
    SelectLinkType.prototype.render = function () {
        var _a = this.props, view = _a.view, link = _a.link;
        var fatLinkTypes = this.state.fatLinkTypes;
        return (React.createElement("label", null,
            "Type",
            React.createElement("select", { className: 'ontodia-form-control', value: link.linkTypeId, onChange: this.onChangeType },
                React.createElement("option", { value: '', disabled: true }, "Select link type"),
                Object.keys(fatLinkTypes).map(function (linkType) {
                    var fatLinkType = fatLinkTypes[linkType];
                    var label = model_1.formatLocalizedLabel(fatLinkType.id, fatLinkType.label, view.getLanguage());
                    return React.createElement("option", { key: linkType, value: linkType }, label);
                }))));
    };
    return SelectLinkType;
}(React.Component));
exports.SelectLinkType = SelectLinkType;
